module.exports = __webpack_public_path__ + "static/user-research-bf15f4b57b7ba327a94d153ec8608078.jpeg";